import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { BookOpenIcon, ClockIcon, ArrowRightIcon, StarIcon } from '@heroicons/react/24/outline';
import { get } from 'lodash';
import moment from 'moment';

const EducationalContentNotification = ({ notification }) => {
  const intl = useIntl();
  const title = get(notification, 'notifiable.title') || intl.formatMessage({ id: 'succession.notifications.educational_content.default_title' });
  const isRead = !!get(notification, 'readAt');
  const readTime = get(notification, 'readAt');

  return (
    <div className={`p-4 border-l-4 ${isRead ? 'border-succession-border bg-succession-bg-tertiary' : 'border-succession-primary bg-succession-primary-10'} hover:shadow-md transition-shadow duration-200`}>
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3">
          {/* Icon */}
          <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${isRead ? 'bg-succession-bg-secondary' : 'bg-succession-primary'}`}>
            <BookOpenIcon className={`w-5 h-5 ${isRead ? 'text-succession-text-muted' : 'text-white'}`} />
          </div>
          
          {/* Badge */}
          <div className={`px-3 py-1 rounded-full text-sm font-bold ${isRead ? 'bg-succession-bg-secondary text-succession-text-muted' : 'bg-succession-primary-20 text-succession-primary'}`}>
            <StarIcon className="w-3 h-3 inline mr-1" />
            {intl.formatMessage({ id: 'succession.notifications.educational_content.badge' })}
          </div>
        </div>

        {/* Unread indicator */}
        {!isRead && (
          <div className="w-3 h-3 bg-succession-primary rounded-full flex-shrink-0"></div>
        )}
      </div>

      {/* Content */}
      <div className="mb-4">
        <p className={`text-base font-medium mb-2 ${isRead ? 'text-succession-text-secondary' : 'text-succession-text-primary'}`}>
          {intl.formatMessage({ id: 'succession.notifications.educational_content.check_out' }, { title })}
        </p>

        <p className={`text-sm ${isRead ? 'text-succession-text-muted' : 'text-succession-text-secondary'}`}>
          {intl.formatMessage({ id: 'succession.notifications.educational_content.subtitle' })}
        </p>
      </div>

      {/* Actions */}
      <div className="flex items-center justify-between">
        <a
          href="/succession/education"
          className={`inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${
            isRead 
              ? 'bg-succession-bg-secondary text-succession-text-secondary hover:bg-succession-hover-bg' 
              : 'bg-succession-primary text-white hover:bg-succession-primary-hover'
          }`}
        >
          <BookOpenIcon className="w-4 h-4 mr-2" />
          {intl.formatMessage({ id: 'succession.notifications.educational_content.browse_now' })}
          <ArrowRightIcon className="w-4 h-4 ml-2" />
        </a>

        {/* Timestamp */}
        <div className="flex items-center text-xs text-succession-text-muted">
          {readTime && (
            <>
              <ClockIcon className="w-3 h-3 mr-1" />
              <span>{intl.formatMessage({ id: 'succession.notifications.educational_content.read_at' }, { time: moment(readTime).fromNow() })}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

EducationalContentNotification.propTypes = {
  notification: PropTypes.shape({
    notifiable: PropTypes.shape({
      title: PropTypes.string,
    }),
    readAt: PropTypes.string,
  }).isRequired,
};

export default EducationalContentNotification; 